var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapuaNewGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3133 27.3137C21.0649 33.5621 10.9343 33.5621 4.68579 27.3137C-1.56259 21.0653 -1.56259 10.9347 4.68585 4.68622C10.9342 -1.56216 20.081 -0.578347 26.3294 5.67009C32.5777 11.9185 33.5616 21.0653 27.3133 27.3137V27.3137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.68613C10.9342 -1.56224 21.0647 -1.56212 27.3132 4.6862C33.5616 10.9346 33.5616 21.0652 27.3132 27.3136",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2276 21.5653L12.4866 22.3625H13.3247L12.6466 22.8551L12.9057 23.6523L12.2276 23.1596L11.5494 23.6523L11.8084 22.8551L11.1304 22.3625H11.9685L12.2276 21.5653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 13.9131L10.5187 15.2418H11.9156L10.7854 16.0628L11.2171 17.3914L10.0869 16.5703L8.9568 17.3914L9.38855 16.0628L8.2583 15.2418H9.6553L10.0869 13.9131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 23.6522L10.5186 24.9808H11.9156L10.7853 25.8018L11.2171 27.1305L10.0869 26.3093L8.9568 27.1305L9.38843 25.8018L8.2583 24.9808H9.65511L10.0869 23.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1709 17.3916L14.6027 18.7202H15.9995L14.8694 19.5412L15.301 20.8699L14.1709 20.0487L13.0407 20.8699L13.4725 19.5412L12.3423 18.7202H13.7392L14.1709 17.3916Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00221 17.3916L6.43402 18.7202H7.83083L6.70071 19.5412L7.13233 20.8699L6.00221 20.0487L4.87202 20.8699L5.30383 19.5412L4.17358 18.7202H5.57052L6.00221 17.3916Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7841 11.8475C26.069 11.1325 25.1399 10.71 24.1415 10.6375L27.1302 8.31291C25.9399 7.1226 24.3445 6.58503 22.7878 6.69872C22.6014 6.02897 22.2461 5.39635 21.7194 4.86966L20.5388 7.23078C20.4614 7.08966 20.3633 6.95685 20.2437 6.83728C19.5645 6.1581 18.4633 6.1581 17.7842 6.83728C17.1051 7.51647 17.105 8.6176 17.7842 9.29678C17.9038 9.41635 18.0366 9.51441 18.1778 9.59191L15.8167 10.7725C16.3435 11.2993 16.9765 11.6549 17.6467 11.8412C17.5326 13.3979 18.0696 14.993 19.26 16.1834L21.8712 12.826C22.0676 12.6326 22.3271 12.5258 22.6031 12.5258C22.8818 12.5258 23.1438 12.6343 23.3409 12.8315C23.538 13.0285 23.6466 13.2906 23.6466 13.5693C23.6466 13.848 23.538 14.11 23.3409 14.3072L24.3248 15.291C24.7846 14.8312 25.0379 14.2197 25.0379 13.5693C25.0379 13.0372 24.8682 12.5313 24.5548 12.1131C25.0114 12.235 25.443 12.4739 25.8005 12.8315C26.8855 13.9164 26.8855 15.6818 25.8005 16.7667L26.7843 17.7505C27.5727 16.9622 28.0068 15.914 28.0068 14.7991C28.0067 13.684 27.5724 12.6359 26.7841 11.8475V11.8475Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapuaNewGuinea);
export default __webpack_public_path__ + "static/media/papua-new-guinea.bb0415c5.svg";
export { ForwardRef as ReactComponent };